export default __webpack_public_path__ + "snapper_floodlight.40ba5f08.png";